export default __webpack_public_path__ + "static/media/125w.d91872e8.svg";